import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import resumenClinicoVideo from "../../assets/videos/presentacion-caso-sc1-ct3.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "../StartGame.css";
import "../Scenario3/Scenario3.css";
import Scenario2NextCta from "./Scenario2NextCta";
import "./Scenario2.css";

const COMMITTEE_STATEMENT =
	'Tras el primer análisis, el comité recibe un informe interno con estas conclusiones:\n\n' +
	'Directora general: "Necesito que la integración de la IA genere resultados visibles en menos de tres meses."\n\n' +
	'Responsable de tecnología: "Ya hay equipos usando herramientas de IA, pero cada uno lo está haciendo con criterios distintos."\n\n' +
	'Responsable de datos: "Tenemos los datos repartidos entre varios sistemas y no siempre están actualizados."\n\n' +
	'Responsable legal: "Ahora mismo no tenemos una política clara sobre privacidad, seguridad ni uso de información sensible."\n\n' +
	'Responsable de marketing: "Todavía no hemos definido métricas claras para saber si la IA está aportando valor real al negocio."\n\n' +
	'Responsable de RRHH: "Parte de la plantilla tiene interés en la IA, pero también hay miedo a perder autonomía o incluso puestos de trabajo."';

/** ms entre cada carácter (ritmo mecanográfico). */
const TYPEWRITER_MS_PER_CHAR = 50;

export default function Scenario2Context3() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 1.0,
	});

	const [visibleLen, setVisibleLen] = useState(0);
	const typingComplete = visibleLen >= COMMITTEE_STATEMENT.length;

	useEffect(() => {
		const id = window.setInterval(() => {
			setVisibleLen((n) => {
				const next = n + 1;
				if (next >= COMMITTEE_STATEMENT.length) {
					window.clearInterval(id);
					return COMMITTEE_STATEMENT.length;
				}
				return next;
			});
		}, TYPEWRITER_MS_PER_CHAR);
		return () => window.clearInterval(id);
	}, []);

	const displayed = COMMITTEE_STATEMENT.slice(0, visibleLen);

	return (
		<div className="start-game-page start-game-page--welcome sc3-context1-dialogue-page sc2-context3-dialogue-page">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Escenario 1 · Diagnóstico
						</span>
						<div className="start-game-avatar-wrap sc3-context1-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									muted={!canPlayWithSound}
									playsInline
									preload="metadata"
									aria-label="Comité: intervenciones en vídeo"
								>
									<source src={resumenClinicoVideo} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>

					<div className="start-game-panel sc3-context1-dialogue-panel">
						<p className="start-game-kicker sc3-context1-kicker">Intervenciones del comité</p>
						<p className="start-game-lead sc3-context1-typewriter sc2-context3-typewriter" aria-live="polite">
							{displayed}
							{typingComplete ? null : (
								<span className="sc3-context1-caret" aria-hidden>
									▍
								</span>
							)}
						</p>
						<div className="start-game-footer sc3-context1-footer">
							<Scenario2NextCta
								navigateTo={ROUTES.SCENARIO2_QUIZ3}
								activeScenario={activeScenario}
								label="Continuar"
								canContinue={typingComplete}
								lockedTitle="Espera a que terminen las intervenciones para continuar"
							/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}
